import onReady from '../utils/onReady';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class MainMenu {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }

    opemMenu(event) {
        event.preventDefault();
        if(this.dom.nav_trigger.classList.contains("nav_opened")) {
            this.closeMenu();
            this.dom.header.classList.add("remove-animation");
        } else {
            this.dom.nav_trigger.classList.add("nav_opened");
            this.dom.main_menu.classList.add("open");
            this.dom.header.classList.add("remove-animation");
        }
    }

    closeMenu(event = null) {
        event.preventDefault();
        this.dom.nav_trigger.classList.remove("nav_opened");
        this.dom.main_menu.classList.remove("open");
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container",
            nav_trigger: container.querySelector(".btn--nav-trigger"),
            close_nav_trigger: container.querySelector(".btn--close"),
            main_menu: container.querySelector(".main-menu"),
            header: document.body.querySelector(".main-header")
        };

        this.dom.nav_trigger.addEventListener("click", (event) => {
           this.opemMenu(event);
        });

        this.dom.close_nav_trigger.addEventListener("click", (event) => {
            this.closeMenu(event);
        });

    }

}


export default MainMenu;